import React from 'react';
import './privacyPolicy.scss';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="privacy-policy">
      <div className="privacy-policy-container">
        <h1>Construction Accounting Privacy Policy</h1>
        <div className="privacy-policy-content">
          <p><strong>Type of website:</strong> Website for Tracking Construction Work</p>
          <p><strong>Effective date:</strong> 28th day of July, 2025</p>

          <p>ca.sitewalker.org (the "Site") is owned and operated by Aura Technology. Aura Technology can be contacted at:</p>

          <div className="contact-info">
            <p>4707 Greenleaf Ct Suite A<br />
              Modesto CA 95356</p>
          </div>

          <h2>Purpose</h2>
          <p>The purpose of this privacy policy (this "Privacy Policy") is to inform users of our Site of the following:</p>
          <ul>
            <li>The personal data we will collect;</li>
            <li>Use of collected data;</li>
            <li>Who has access to the data collected;</li>
            <li>The rights of Site users; and</li>
            <li>The Site's cookie policy.</li>
          </ul>
          <p>This Privacy Policy applies in addition to the terms and conditions of our Site.</p>

          <h2>Consent</h2>
          <p>By using our Site users agree that they consent to:</p>
          <ul>
            <li>The conditions set out in this Privacy Policy; and</li>
            <li>The collection, use, and retention of the data listed in this Privacy Policy.</li>
          </ul>

          <h2>Personal Data We Collect</h2>
          <p>We only collect data that helps us achieve the purpose set out in this Privacy Policy. We will not collect any additional data beyond the data listed below without notifying you first.</p>

          <h3>Data Collected Automatically</h3>
          <p>When you visit and use our Site, we may automatically collect and store the following information:</p>
          <ul>
            <li>Location.</li>
          </ul>

          <h3>Data Collected in a Non-Automatic Way</h3>
          <p>We may also collect the following data when you perform certain functions on our Site:</p>
          <ul>
            <li>First and last name; and</li>
            <li>Email address.</li>
          </ul>
          <p>This data may be collected using the following methods:</p>
          <ul>
            <li>Creating an account.</li>
          </ul>

          <h2>How We Use Personal Data</h2>
          <p>Data collected on our Site will only be used for the purposes specified in this Privacy Policy or indicated on the relevant pages of our Site. We will not use your data beyond what we disclose in this Privacy Policy.</p>

          <p>The data we collect automatically is used for the following purposes:</p>
          <ul>
            <li>Recording data about hours worked on construction sites.</li>
          </ul>

          <p>The data we collect when the user performs certain functions may be used for the following purposes:</p>
          <ul>
            <li>Communication.</li>
          </ul>

          <h2>Who We Share Personal Data With</h2>
          <h3>Employees</h3>
          <p>We may disclose user data to any member of our organization who reasonably needs access to user data to achieve the purposes set out in this Privacy Policy.</p>

          <h3>Third Parties</h3>
          <p>We may share user data with the following third parties:</p>
          <ul>
            <li>Companies that register with us.</li>
          </ul>
          <p>We may share the following user data with third parties:</p>
          <ul>
            <li>Location construction sites.</li>
          </ul>
          <p>We may share user data with third parties for the following purposes:</p>
          <ul>
            <li>Reporting on cost codes and time spent on each.</li>
          </ul>
          <p>Third parties will not be able to access user data beyond what is reasonably necessary to achieve the given purpose.</p>

          <h2>Other Disclosures</h2>
          <p>We will not sell or share your data with other third parties, except in the following cases:</p>
          <ul>
            <li>If the law requires it;</li>
            <li>If it is required for any legal proceeding;</li>
            <li>To prove or protect our legal rights; and</li>
            <li>To buyers or potential buyers of this company in the event that we seek to sell the company.</li>
          </ul>
          <p>If you follow hyperlinks from our Site to another Site, please note that we are not responsible for and have no control over their privacy policies and practices.</p>

          <h2>How Long We Store Personal Data</h2>
          <p>User data will be stored until the purpose the data was collected for has been achieved.</p>
          <p>You will be notified if your data is kept for longer than this period.</p>

          <h2>How We Protect Your Personal Data</h2>
          <p>In order to protect your security, we use the strongest available browser encryption and store all of our data on servers in secure facilities. All data is only accessible to our employees. Our employees are bound by strict confidentiality agreements and a breach of this agreement would result in the employee's termination.</p>
          <p>While we take all reasonable precautions to ensure that user data is secure and that users are protected, there always remains the risk of harm. The Internet as a whole can be insecure at times and therefore we are unable to guarantee the security of user data beyond what is reasonably practical.</p>

          <h2>Children</h2>
          <p>We do not knowingly collect or use personal data from children under 13 years of age. If we learn that we have collected personal data from a child under 13 years of age, the personal data will be deleted as soon as possible. If a child under 13 years of age has provided us with personal data their parent or guardian may contact our privacy officer.</p>

          <h2>How to Access, Modify, Delete, or Challenge the Data Collected</h2>
          <p>If you would like to know if we have collected your personal data, how we have used your personal data, if we have disclosed your personal data and to who we disclosed your personal data, or if you would like your data to be deleted or modified in any way, please contact our privacy officer here:</p>

          <div className="contact-form">
            <p>Privacy Officer</p>
            <p>4707 Greenleaf Ct Suite A<br />
              Modesto CA 95356</p>
          </div>

          <h2>Do Not Track Notice</h2>
          <p>Do Not Track ("DNT") is a privacy preference that you can set in certain web browsers. We do not track the users of our Site over time and across third party websites and therefore do not respond to browser-initiated DNT signals. We are not responsible for and cannot guarantee how any third parties who interact with our Site and your data will respond to DNT signals.</p>

          <h2>Cookie Policy</h2>
          <p>A cookie is a small file, stored on a user's hard drive by a website. Its purpose is to collect data relating to the user's browsing habits. You can choose to be notified each time a cookie is transmitted. You can also choose to disable cookies entirely in your internet browser, but this may decrease the quality of your user experience.</p>
          <p>We use the following types of cookies on our Site:</p>
          <h3>Functional cookies</h3>
          <p>Functional cookies are used to remember the selections you make on our Site so that your selections are saved for your next visits.</p>

          <h2>Modifications</h2>
          <p>This Privacy Policy may be amended from time to time in order to maintain compliance with the law and to reflect any changes to our data collection process. When we amend this Privacy Policy we will update the "Effective Date" at the top of this Privacy Policy. We recommend that our users periodically review our Privacy Policy to ensure that they are notified of any updates. If necessary, we may notify users by email of changes to this Privacy Policy.</p>

          <h2>Contact Information</h2>
          <p>If you have any questions, concerns or complaints, you can contact our privacy officer, James Daniels, at:</p>

          <div className="contact-info">
            <p>4707 Greenleaf Ct Suite A<br />
              Modesto CA 95356</p>
          </div>

          <div className="copyright">
            <p>©2002-2023 LawDepot.com®</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 